/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 스케쥴 취소 마감 시간 타입
 */
export type ScheduleReservationCutoffType = 'Day' | 'Minute';

export const ScheduleReservationCutoffType = {
    Day: 'Day' as ScheduleReservationCutoffType,
    Minute: 'Minute' as ScheduleReservationCutoffType
};

